import React from 'react';

import { useIntl } from 'react-intl-next';

import { Field as AtlaskitField } from '@atlaskit/form';
import InlineMessage from '@atlaskit/inline-message';
import { Text } from '@atlaskit/primitives/compiled';
import { type ValueType } from '@atlaskit/select';
import { getUsers } from '@atlassian/eoc-auto-complete';
import { isRequired, useValidators } from '@atlassian/eoc-common';
import { Row } from '@atlassian/eoc-schedule-common';

import { AutoCompleteWithNoOne } from '../../auto-complete-with-noone';
import { type AutoCompleteWithNoOneItem } from '../../auto-complete-with-noone/custom-option/types';

import { getExtraSelectProps } from './constants';
import { messages } from './messages';
import { type OverridenWithProps } from './types';

const OverridenWith: React.FC<OverridenWithProps> = ({ isLoading, ...rest }) => {
	const intlApi = useIntl();

	const isRequiredValidator = useValidators([isRequired()]);

	return (
		<AtlaskitField<ValueType<AutoCompleteWithNoOneItem, false>>
			{...rest}
			id="responder"
			name="responder"
			validate={isRequiredValidator}
		>
			{({ fieldProps, error }) => (
				<Row
					variant="inline"
					htmlFor="responder"
					label={intlApi.formatMessage(messages.overrideWith)}
				>
					<>
						<AutoCompleteWithNoOne
							{...fieldProps}
							{...getExtraSelectProps()}
							{...(isLoading && { isLoading: true })}
							{...(error && { isError: true })}
							spacing="compact"
							appearance="subtle"
							endpoints={[getUsers]}
							menuShouldScrollIntoView={false}
						/>
						{error && (
							<InlineMessage appearance="error" iconLabel={error}>
								<Text as="p">{error}</Text>
							</InlineMessage>
						)}
					</>
				</Row>
			)}
		</AtlaskitField>
	);
};

export { OverridenWith };
